import type { Organization, WithContext } from 'schema-dts';
import {
	mailSouPilar,
	pilarFormattedPhone,
	pilarHomesInstagram,
	urlSouPilar
} from '~/constants';

export function useWebsiteJsonLd() {
	const websiteUrl = useRuntimeConfig().public.ORIGIN;

	const pilarOrganization: WithContext<Organization> = {
		'@type': 'Organization',
		'@context': 'https://schema.org',
		'@id': 'pilar-organization',
		name: 'Pilar',
		url: urlSouPilar,
		telephone: pilarFormattedPhone,
		email: mailSouPilar,
		sameAs: [
			'https://www.instagram.com/sou_pilar',
			'https://facebook.com/soupilarbr',
			'https://www.linkedin.com/company/soupilar',
			'https://www.youtube.com/@poweredbypilar',
			'https://open.spotify.com/show/1RIfOWEWWKRY1gXOgymgup'
		],
		logo: {
			'@type': 'ImageObject',
			url: getUrlFromStaticDNS('/pilar-logo.svg')
		}
	};

	const pilarHomesOrganization: WithContext<Organization> = {
		'@type': 'Organization',
		'@context': 'https://schema.org',
		'@id': 'pilar-homes-organization',
		name: 'PilarHomes',
		url: websiteUrl,
		telephone: pilarFormattedPhone,
		email: mailSouPilar,
		sameAs: [pilarHomesInstagram],
		parentOrganization: pilarOrganization
	};

	useJsonld(() => pilarHomesOrganization);
	useJsonld(() => ({
		'@context': 'https://schema.org',
		'@type': 'WebSite',
		name: 'PilarHomes',
		url: websiteUrl,
		maintainer: {
			'@id': 'pilar-organization'
		}
	}));
}
